export const GET_DATA_POSITIONS_USERS   = "GET_DATA_POSITIONS_USERS"
export const GET_DATA_HISTORICAL_QUINELA_USERS   = "GET_DATA_HISTORICAL_QUINELA_USERS"
